/** @format */

import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

import { Store, select } from '@ngrx/store';
import { filter } from 'rxjs/operators';

import { UtilityService } from '@shared/utils/services';
import { KillswitchService } from '@shared/data-access/services';
import { chain } from 'chains/chain';
import {
	AppProductReviewState,
	InvalidResponse,
	selectProductIncludedInformation,
	selectProductReviewSummary
} from '@product-reviews/data-access';

@Component({
    selector: 'product-reviews-aggregated-rating',
    templateUrl: './aggregated-rating.component.html',
    standalone: false
})
export class AggregatedRatingComponent {
	isBot = false;
	reviewsSEOServer = false;
	reviewsSEOClient = false;

	productReviewed$ = this.ngrxStore.pipe(select(selectProductIncludedInformation));
	reviewSummary$ = this.ngrxStore.pipe(
		select(selectProductReviewSummary),
		filter(
			(reviewSummary) =>
				!(reviewSummary instanceof InvalidResponse) && !!reviewSummary.reviewCount
		)
	);

	constructor(
		private utilityService: UtilityService,
		private killSwitchService: KillswitchService,
		private ngrxStore: Store<AppProductReviewState>,
		@Inject(PLATFORM_ID) private platformId
	) {
		this.killSwitchService.getKillSwitchesEnvironment$().subscribe((data) => {
			this.reviewsSEOServer = this.utilityService.checkKillSwitch(
				'reviewsSEOServer',
				data,
				chain.chainIdentifierAbbr
			);

			this.reviewsSEOClient = this.utilityService.checkKillSwitch(
				'reviewsSEOClient',
				data,
				chain.chainIdentifierAbbr
			);
		});

		this.isBot = !isPlatformBrowser(this.platformId);
	}
}
